<template>
  <div class="common-box">
    <el-form inline ref="form" class="search-form common-box-search-form" label-position="right" :model="form"
      label-width="90px">
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="使用单位：">
            <el-select size="mini" v-model="form.propertyUnitId" filterable placeholder="请选择所属单位" clearable
              reserve-keyword :remote="true" @change="handleSearchListData" :remote-method="searchUnitList"
              @visible-change="searchUnitList('')">
              <el-option v-for="item in unitList" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属项目：">
            <el-select size="mini" v-model="form.projectId" filterable placeholder="请选择所属项目" clearable reserve-keyword
              :remote="true" @change="handleSearchListData" :remote-method="searchProjectList"
              @visible-change="searchProjectList('')">
              <el-option v-for="item in projectList" :key="item.id" :label="item.projectName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用编号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.useCertificateNumber"
              placeholder="请输入使用编号" clearable></el-input>
          </el-form-item>
          <AddreassSelect :isSearch="false" :warning="addressWarn" :showDetailAddress="showDetailAddress"
            :addressName="addressName" class="input-with-col2" @change="setPojectAddress"></AddreassSelect>
          <el-form-item label="电梯位置：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.liftLocation" placeholder="请输入电梯位置"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="所属部门：">
            <el-cascader placeholder="请选择所属部门" :options="departmentTree" :props="propsTree" filterable
              @change="handleDepartment" ref="cascader" collapse-tags v-model="departmentIdList"></el-cascader>
          </el-form-item>
          <el-form-item label="工单编号：">
            <el-input @change="handleSearchListData" size="mini" v-model.trim="form.orderNo" placeholder="请输入工单编号"
              clearable></el-input>
          </el-form-item>
          <el-form-item label="添加时间：">
            <el-date-picker v-model="form.createTimeBetween" size="mini" type="daterange" range-separator="至"
              start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd" unlink-panels
              clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="是否签字：">
            <el-select size="mini" v-model="form.signatureStatus" placeholder="请选择" clearable
              @change="handleSearchListData">
              <el-option v-for="item in isSignList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="超期：">
            <el-select size="mini" v-model="form.overdueStatus" placeholder="请选择" clearable
              @change="handleSearchListData">
              <el-option v-for="item in isSignList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否收费：">
            <el-select size="mini" v-model="form.payStatus" placeholder="请选择" clearable @change="handleSearchListData">
              <el-option v-for="item in payStatusList" :key="item.code" :label="item.name"
                :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位置异常：">
            <el-select size="mini" v-model="form.locationStatus" placeholder="请选择" clearable
              @change="handleSearchListData">
              <el-option v-for="item in isSignList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维修单状态：" class="mr0" prop="status">
            <el-select size="mini" v-model="form.status" placeholder="请选择电梯类型" clearable filterable
              @change="handleSearchListData" value-key="dictionaryCode">
              <el-option v-for="item in WXDZTDicts" :key="item.dictionaryCode" :label="item.dictionaryValue"
                :value="item.dictionaryCode"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button size="mini" type="primary" class="plr28" @click="handleDelete"
          v-if="hasRole['WXGDSC']">删除</el-button>
        <el-button size="mini" type="primary" @click="exportEXAIL" plain class="plr28"
          v-if="hasRole['WXGDDC']">导出</el-button>
          <span>年度维修费总计：{{ materialTotalRevenue }}</span>
          <span>年度维修费总计利润：{{ residualProfit }}</span>
      </div>
      <div class="table__container">
        <el-table v-loading="tableLoading" :data="list" height="100%" border style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column show-overflow-tooltip prop="projectName" label="项目名称" width="160"
            fixed="left"></el-table-column>
          <el-table-column show-overflow-tooltip prop="liftLocation" label="电梯位置" width="100"
            fixed="left"></el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorUserName" label="维保员" width="100"></el-table-column>

          <el-table-column show-overflow-tooltip prop="startTime" label="开始时间" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="endTime" label="结束时间" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="payStatusName" label="是否收费" width="60">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="locationStatusName" label="位置异常" width="80">
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="signatureStatusName" label="签字" width="60"></el-table-column>
          <el-table-column show-overflow-tooltip prop="statusName" label="维修单状态" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="faultReason" label="故障原因" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="propertyUnitName" label="使用单位" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="materialTotalRevenue" label="材料收入总金额" width="90"></el-table-column>
          <el-table-column show-overflow-tooltip prop="materialTotalCostAmount" label="材料成本总金额" width="90"></el-table-column>
          <el-table-column show-overflow-tooltip prop="residualProfit" label="剩余利润" width="90"></el-table-column>
          <el-table-column show-overflow-tooltip prop="orderNo" label="工单编号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="elapsedTime" label="耗时" width="90"></el-table-column>
          <el-table-column show-overflow-tooltip prop="contactsPhone" label="省市区" width="100">
            <template
              slot-scope="scope">{{scope.row.provinceName ? scope.row.provinceName + ',' : ''}}{{scope.row.provinceName ? scope.row.provinceName + "," : ''}}{{scope.row.districtName}}</template>
          </el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="98px" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="text" v-if="hasRole['WXGDXQ']" @click="handleCheck(scope.row)">查看</el-button>
              <div class="btn-divide" v-if="hasRole['WXGDXQ']"></div>
              <el-button size="mini" v-if="hasRole['WXGDSC']" type="text"
                @click="handleDeleteUnit(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
    <check-order v-if="checkOrder" :editData="orderDetail" @cancel="checkOrder = false"></check-order>
  </div>
</template>

<script>
  import {
    getDepartmentTree,
  } from "@/api/ElevatorManagement";
  import {
    getOrderList,
    deleteOrder,
    exportPDF,
    exportEXAIL,
    getProjectSimpleList,
    getPropertyUnitSimpleList
  } from '@/api/RecoveryWorkOrder'
  import AddreassSelect from "@/components/AddreassSelect/AddreassSelect";
  import CheckOrder from './components/CheckOrder'
  import {
    mapState
  } from "vuex";
  export default {
    name: 'RecoveryWorkOrder',
    components: {
      CheckOrder,
      AddreassSelect
    },
    data() {
      return {
        form: {
          departmentIdList: [],
          propertyUnitId: '',
          projectId: '',
          useCertificateNumber: '',
          cityCode: '',
          districtCode: '',
          provinceCode: '',
          liftLocation: '',
          orderNo: '',
          startCreateTime: '',
          endCreateTime: '',
          createTimeBetween: null,
          signatureStatus: '',
          overdueStatus: '',
          locationStatus: ''

        },
        tableLoading: false,
        list: [],
        multipleSelection: [],
        pageIndex: 1,
        pageSize: 50,
        total: 0,
        checkOrder: false,
        orderDetail: {},
        unitList: [],
        projectList: [],
        addressWarn: false,
        showDetailAddress: false,
        addressName: '省市区',
        isSignList: [{
            code: 1,
            name: "是"
          },
          {
            code: 2,
            name: "否"
          }
        ],
        payStatusList: [{
            code: "0",
            name: "免费"
          },
          {
            code: "1",
            name: "收费"
          }
        ],
        departmentTree: [],
        propsTree: {
          multiple: true,
          value: "id",
          label: "departmentName",
          children: "childrenList",
          // checkStrictly: true
        },
        departmentIdList: [],
        residualProfit: '',
        materialTotalRevenue: '',
      }
    },
    computed: {
      hasRole: function() {
        return this.$store.getters['common/promise/getRole'](this.$route.path);
      },
      ...mapState("common/dictionary", ["WXDZTDicts"]),
    },
    created() {
      this.getListData()
      this.getDepartmentTree()
    },
    methods: {
      async getDepartmentTree() {
        const res = await getDepartmentTree({
          pageIndex: 1,
          pageSize: 1000
        });
        if (res.code === 200) {
          this.departmentTree = res.data;
        }
      },
      async getListData() {
        this.tableLoading = true
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        if (this.form.createTimeBetween) {
          delete params.createTimeBetween
          params.endCreateTime = this.form.createTimeBetween[1]
          params.startCreateTime = this.form.createTimeBetween[0]
        }
        const res = await getOrderList(params)
        if (res.code === 200) {
          this.total = res.data.total
          this.list = res.data.list
          const statisticsData = res.data.statisticsData;
          if(statisticsData) {
            this.materialTotalRevenue = statisticsData.materialTotalRevenue;
            this.residualProfit = statisticsData.residualProfit;
          } else {
            this.materialTotalRevenue = '';
            this.residualProfit = '';
          }
        }
        this.tableLoading = false
      },
      handleSearch() {
        this.pageIndex = 1
        this.getListData()
      },
      handleRefresh() {
        for (let key in this.form) {
          if (Array.isArray(this.form[key])) {
            this.form[key] = []
          } else {
            this.form[key] = ''
          }
        }
        this.pageIndex = 1
        this.getListData()
      },
      handleSearchListData() {
        this.pageIndex = 1
        this.getListData()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      handleDeleteUnit(row) {
        const idList = [row.orderId]
        this.deleteOrder(idList)
      },
      handleCheck(row) {
        this.orderDetail = row
        this.checkOrder = true
      },
      handleDelete() {
        if (!this.multipleSelection.length) {
          this.$message.warning('请选择要删除的行')
          return
        }
        const idList = this.multipleSelection.map(item => item.orderId)
        this.deleteOrder(idList)
      },
      deleteOrder(idList) {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await deleteOrder({
            idList
          })
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getListData()
          }
        }).catch((err) => {
          console.log(err)
        })

      },
      exportPDF() {
        // const params = {
        //   pageIndex: this.pageIndex,
        //   pageSize: this.pageSize
        // }
        // for(let key in this.form) {
        //   if (this.form[key])
        //     params[key] = this.form[key]
        // }
        if (!this.multipleSelection.length || this.multipleSelection.length != 1) {
          this.$message.warning('请选择要导出的一行，仅支持单个导出')
          return
        }
        exportPDF({
          orderId: this.multipleSelection[0].orderId
        })
      },
      exportEXAIL() {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        for (let key in this.form) {
          if (this.form[key])
            params[key] = this.form[key]
        }
        exportEXAIL(params)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.getListData()
      },
      async searchUnitList(keyword) {
        const res = await getPropertyUnitSimpleList({
          keyword: keyword,
          size: 1000,
        });
        if (res.code === 200) {
          this.unitList = res.data;
        }
      },
      async searchProjectList(keyword) {
        const res = await getProjectSimpleList({
          keyword: keyword,
          size: 1000,
        });
        if (res.code === 200) {
          this.projectList = res.data;
        }
      },
      setPojectAddress(data) {
        this.form.address = data.addressData; // 项目地址 详细地址
        this.form.provinceCode = data.provinceCode; // 项目地址省级 code
        this.form.provinceName = data.provinceName; // 项目地址省级 name
        this.form.cityCode = data.cityCode; // 项目地址城市 code
        this.form.cityName = data.cityName; // 项目地址城市 name
        this.form.districtCode = data.townCode; // 项目地址区级 code
        this.form.districtName = data.townName; // 项目地址区级 name
      },
      handleDepartment(val) {
        this.form.departmentIdList = [];
        const nodes = this.$refs.cascader.getCheckedNodes();
        nodes.forEach((item) => {
          this.form.departmentIdList.push(item.data.id);
        });
        this.handleSearchListData();
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/RecoveryWorkOrder/RecoveryWorkOrder.vue